import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const CONTENT_STALE_TIME = 60 * 60 * 1000;

const getMarkdownUrl = (post) => {
  if (typeof post?.markdownUrl === 'string' && post.markdownUrl.trim()) {
    return post.markdownUrl;
  }

  return `/blog/${post.id}.md`;
};

export function useBlogIndex(language) {
  return useQuery({
    queryKey: ['blog-index', language],
    queryFn: async () => {
      const { data } = await axios.get(`${API_BASE_URL}/api/blog/posts`, { params: { language } });
      return data;
    },
    staleTime: CONTENT_STALE_TIME,
    gcTime: CONTENT_STALE_TIME,
    refetchOnWindowFocus: false,
  });
}

export function useBlogPost(postId) {
  return useQuery({
    queryKey: ['blog-post', postId],
    queryFn: async () => {
      let data;

      try {
        ({ data } = await axios.get(`${API_BASE_URL}/api/blog/posts/${postId}`));
      } catch (error) {
        if (error?.response?.status === 404) return null;
        throw error;
      }

      const markdownUrl = getMarkdownUrl(data);
      const { data: body } = await axios.get(markdownUrl, { responseType: 'text' });

      return { ...data, body, markdownUrl };
    },
    enabled: Boolean(postId),
    staleTime: CONTENT_STALE_TIME,
    gcTime: CONTENT_STALE_TIME,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
